// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"be942e2e","239":"c3bf71ec","453":"89a3d521","732":"1c6524a3"}[chunkId] + ".chunk.js";
};